exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon_size__xxs__1b8BC{font-size:.6rem}.icon_size__xs__1dZCp{font-size:.8rem}.icon_size__s__31tnW{font-size:1.2rem}.icon_size__mds__Xdb3J{font-size:1.4rem}.icon_size__md__3xdxI{font-size:1.6rem}.icon_size__l__2SkxW{font-size:2rem}.icon_size__xl__3s9Vx{font-size:2.4rem}.icon_size__xxl__3GROV{font-size:2.8rem}.icon_size__xxxl__22-cf{font-size:6.4rem}.icon_disabledIcon__3tpTI{opacity:.6}[dir] .icon_disabledIcon__3tpTI{cursor:not-allowed}", ""]);

// Exports
exports.locals = {
	"size__xxs": "icon_size__xxs__1b8BC",
	"size__xs": "icon_size__xs__1dZCp",
	"size__s": "icon_size__s__31tnW",
	"size__mds": "icon_size__mds__Xdb3J",
	"size__md": "icon_size__md__3xdxI",
	"size__l": "icon_size__l__2SkxW",
	"size__xl": "icon_size__xl__3s9Vx",
	"size__xxl": "icon_size__xxl__3GROV",
	"size__xxxl": "icon_size__xxxl__22-cf",
	"disabledIcon": "icon_disabledIcon__3tpTI"
};